import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'
import { RemoteLoadTests } from '../../../data/usecases/load-tests/remote-load-tests'

export const makeLoadTests = (cd:string) => new RemoteLoadTests(`/cotacao/testLoadByConstruto?cdConstruto${cd}`, makeAxiosHttpClient())
